// extracted by mini-css-extract-plugin
export default {"counter":"RKE1MiGv","desktop":"desktop","mobile":"mobile"};